export default function SafetySection() {
  const safetyMeasures = [
    {
      icon: 'ri-file-text-line',
      title: '譲渡契約書の作成',
      description: '法的に有効な契約書を作成し、双方の権利を保護します'
    },
    {
      icon: 'ri-search-eye-line',
      title: '買い手のスクリーニング',
      description: '買い手候補の信頼性を事前に確認します'
    },
    {
      icon: 'ri-shield-cross-line',
      title: '反社会的勢力等の排除',
      description: '反社会的勢力との取引を徹底的に排除します'
    },
    {
      icon: 'ri-id-card-line',
      title: 'ご身分証の確認',
      description: '本人確認を徹底し、なりすまし等を防止します'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center px-6 py-3 bg-teal-50 rounded-full mb-6">
            <i className="ri-shield-check-line text-teal-600 text-xl mr-3"></i>
            <span className="text-sm font-bold text-teal-600">SAFETY</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">
            安心安全な<span className="bg-gradient-to-r from-teal-500 to-cyan-500 bg-clip-text text-transparent">売却</span>のために
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            弊社では安心安全な会社のご売却のために、以下の取り組みを行っております
          </p>
        </div>

        {/* Safety Measures Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {safetyMeasures.map((measure, index) => (
            <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 group">
              <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <i className={`${measure.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-base font-black text-gray-900 mb-2">{measure.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{measure.description}</p>
            </div>
          ))}
        </div>

        {/* Transaction Flow */}
        <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-3xl p-10 border-2 border-teal-200">
          <h3 className="text-2xl font-black text-gray-900 mb-8 text-center">
            お取引時の流れ
          </h3>
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                <strong className="text-gray-900">売主様、買主様の双方に一切のリスクが生じないよう、以下のような流れとなります。</strong>
              </p>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-black">1</span>
                  </div>
                  <div>
                    <h4 className="font-black text-gray-900 mb-2">変更登記の実施前に契約書に捺印</h4>
                    <p className="text-sm text-gray-600">売主様から印鑑類など、買主様からはお代金を、弊社にお預けして頂きます。</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-black">2</span>
                  </div>
                  <div>
                    <h4 className="font-black text-gray-900 mb-2">登記変更の完了</h4>
                    <p className="text-sm text-gray-600">登記変更が完了次第、お代金のお支払い、法人物品のお引渡しをいたします。</p>
                  </div>
                </div>

                <div className="bg-teal-50 rounded-xl p-6 border border-teal-200">
                  <div className="flex items-start gap-3">
                    <i className="ri-shield-check-line text-2xl text-teal-600 flex-shrink-0"></i>
                    <div>
                      <h4 className="font-black text-gray-900 mb-2">安全性の保証</h4>
                      <p className="text-sm text-gray-700">
                        上記により、<strong>代金未払いでの登記実施（売主保護）</strong>、<strong>お代金の持ち逃げ（買主保護）</strong>などを防ぎます。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
